import {Component, OnDestroy, OnInit} from '@angular/core';
import { Subscription } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
import { Meta, Title } from '@angular/platform-browser';
import { Angulartics2 } from 'angulartics2';
import { ActivatedRoute, Router } from '@angular/router';
import { SeoService } from '../common/services/seo.service';
import {IPageChangeData} from '../common/data-objects/IPageChangeData';
import {PostDO} from '../common/data-objects/PostDO';
import {PostsService} from '../common/services/posts.service';
import urlSlug from 'url-slug';

@Component({
  selector: 'app-cartoons-page',
  templateUrl: './cartoons-page.component.html',
  styleUrls: ['./cartoons-page.component.scss']
})
export class CartoonsPageComponent implements OnInit, OnDestroy {
  posts: PostDO[];
  page: number;
  itemsCount: number;
  isLoading = true;
  pagesCount: number;
  private getDataSubscription: Subscription;

constructor(
    private toastr: ToastrService,
    private titleService: Title,
    private angulartics2: Angulartics2,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private meta: Meta,
    private seoService: SeoService,
    private postsService: PostsService
  ) {
    this.seoService.setTitle('Desene animate biblice - Fun Bible');
    this.seoService.setDescription('Peste 200 de desene animate biblice');
    this.meta.updateTag({ property: 'og:url', content: 'https://funbible.net/cartoons/' });
    this.meta.updateTag({ property: 'og:image', content: 'https://funbible.net/assets/tv.jpg' });
    const initialKeywords = ['desene animate crestine', 'filme animate biblice', 'animatii', 'desene animate online', 'desen animat', 'youtube desene animate', 'filme animate online', 'film animat', 'desen animate', 'desenea animate'].join();
    this.meta.updateTag({property: 'keywords', content: initialKeywords});
    this.angulartics2.eventTrack.next({
      action: 'cartoons',
      properties: { category: 'pageView' },
    });
  }

  ngOnInit() {
  }

  ngOnDestroy() {
    if (this.getDataSubscription) {
      this.getDataSubscription.unsubscribe();
    }
  }

  getData({searchText, page}: IPageChangeData) {
    this.isLoading = true;
    this.getDataSubscription = this.postsService.getCartoonsPages(searchText, page).subscribe((postsData) => {
      this.posts = postsData.posts;
      this.pagesCount = postsData.pagesCount;
      this.itemsCount = postsData.itemsCount;
      this.isLoading = false;
    }, () => {
      this.toastr.error('Acest conținut nu s-a putut încărca!');
      this.isLoading = false;
    });
  }
}
